import React from 'react';

const Welcome = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* 로고 이미지 */}
        <img
          src="/mascot_main.png"
          alt="황금거북이"
          style={styles.mascot}
        />

        {/* 타이틀 */}
        <h1 style={styles.title}>황금거북이</h1>
        <p style={styles.subtitle}>Golden Turtle</p>

        {/* 설명 */}
        <div style={styles.descriptionBox}>
          <p style={styles.description}>
            매일 황금거북을 열고 포인트를 받아보세요!
          </p>
          <p style={styles.descriptionSub}>
            광고 시청으로 포인트를 적립하고, 이벤트 응모와 현금 인출까지.
            <br />
            지금 바로 시작하세요.
          </p>
        </div>

        {/* 기능 소개 */}
        <div style={styles.features}>
          <div style={styles.featureItem}>
            <span style={styles.featureIcon}>🐢</span>
            <div>
              <strong style={styles.featureTitle}>황금거북 열기</strong>
              <p style={styles.featureDesc}>매일 지급되는 황금거북을 열어 포인트를 획득하세요</p>
            </div>
          </div>
          <div style={styles.featureItem}>
            <span style={styles.featureIcon}>🎫</span>
            <div>
              <strong style={styles.featureTitle}>이벤트 응모</strong>
              <p style={styles.featureDesc}>응모권으로 24K 순금 이벤트에 참여하세요</p>
            </div>
          </div>
          <div style={styles.featureItem}>
            <span style={styles.featureIcon}>💰</span>
            <div>
              <strong style={styles.featureTitle}>포인트 출금</strong>
              <p style={styles.featureDesc}>적립한 포인트를 현금으로 인출할 수 있습니다</p>
            </div>
          </div>
        </div>

        {/* 다운로드 버튼 */}
        <a
          href="https://play.google.com/store/apps/details?id=com.add.claw_reward"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.downloadButton}
        >
          Google Play에서 다운로드
        </a>

        {/* 푸터 */}
        <div style={styles.footer}>
          <a href="/terms" style={styles.footerLink}>이용약관</a>
          <span style={styles.footerDivider}>|</span>
          <a href="/privacy" style={styles.footerLink}>개인정보처리방침</a>
        </div>

        <p style={styles.copyright}>© 2026 ADD. All rights reserved.</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #F5F6F7 0%, #E8F5E0 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 20px',
  },
  content: {
    maxWidth: 480,
    width: '100%',
    textAlign: 'center',
  },
  mascot: {
    width: 200,
    height: 200,
    objectFit: 'contain',
    marginBottom: 24,
  },
  title: {
    fontSize: 36,
    fontWeight: 800,
    color: '#2D9500',
    margin: '0 0 4px 0',
  },
  subtitle: {
    fontSize: 16,
    color: '#969696',
    margin: '0 0 32px 0',
    fontWeight: 500,
  },
  descriptionBox: {
    marginBottom: 40,
  },
  description: {
    fontSize: 20,
    fontWeight: 600,
    color: '#2C2F30',
    margin: '0 0 8px 0',
  },
  descriptionSub: {
    fontSize: 14,
    color: '#595C5D',
    lineHeight: 1.6,
    margin: 0,
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 40,
    textAlign: 'left',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    background: '#FFFFFF',
    borderRadius: 16,
    padding: '20px 24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  },
  featureIcon: {
    fontSize: 32,
    lineHeight: 1,
    flexShrink: 0,
  },
  featureTitle: {
    fontSize: 16,
    color: '#2C2F30',
    display: 'block',
    marginBottom: 4,
  },
  featureDesc: {
    fontSize: 13,
    color: '#595C5D',
    margin: 0,
    lineHeight: 1.4,
  },
  downloadButton: {
    display: 'inline-block',
    background: '#2D9500',
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: 700,
    padding: '16px 48px',
    borderRadius: 12,
    textDecoration: 'none',
    marginBottom: 40,
    transition: 'opacity 0.2s',
  },
  footer: {
    marginBottom: 12,
  },
  footerLink: {
    fontSize: 13,
    color: '#969696',
    textDecoration: 'none',
  },
  footerDivider: {
    margin: '0 8px',
    color: '#D1D5D7',
  },
  copyright: {
    fontSize: 12,
    color: '#B4B4B4',
    margin: 0,
  },
};

export default Welcome;
